export const EXAM_SPECIALTY_IDS = {
  PE: {
    CARDIOLOGY: 1,
    MEDICINE: 2,
    MUSCULOSKELETAL: 3,
    TRIAGE: 4,
    SPIROMETRY: 5,
    NEUROLOGY: 6,
    DENTISTRY: 7,
    OPHTHALMOLOGY: 8,
    AUDIOMETRY: 9,
    LABORATORY: 10,
    PSYCHOLOGY: 11,
    PSYCHOSENSOMETRIC: 12,
    ULTRASOUND: 13,
    RADIOLOGY: 14,
    ELECTROENCEPHALOGRAM: 15,
    CARDIOLOGY_INTERCONSULTATION: 17,
    ENDOCRINOLOGY_INTERCONSULTATION: 18,
    INTERNAL_MEDICINE_INTERCONSULTATION: 19,
    NUTRITION_INTERCONSULTATION: 20,
    PULMONOLOGY_INTERCONSULTATION: 21,
    OPHTHALMOLOGY_INTERCONSULTATION: 22,
    OTOLARYNGOLOGY_INTERCONSULTATION: 23,
    GENERAL_SURGERY_INTERCONSULTATION: 24,
    HEMATOLOGY_INTERCONSULTATION: 25,
    TRAUMATOLOGY_INTERCONSULTATION: 26,
    PSYCHIATRY_INTERCONSULTATION: 27,
    NEUROLOGY_INTERCONSULTATION: 28,
    PHYSICAL_MEDICINE_REHAB_INTERCONSULTATION: 29,
    NEPHROLOGY_INTERCONSULTATION: 30,
    GASTROENTEROLOGY_INTERCONSULTATION: 31,
    UROLOGY_INTERCONSULTATION: 32,
    GYNECOLOGY_INTERCONSULTATION: 33,
  },
};